import { differenceInCalendarDays, getDay, getDaysInMonth, startOfWeek } from "date-fns";
import DateTime from "../../../functions/lib/dateTime.js";

export function generateCalendarForMonth(year, month, events)
{
	let date = new Date(year, month - 1, 1);
	let first = differenceInCalendarDays(date, startOfWeek(date, { weekStartsOn: 1}))

	let daysInMonth = getDaysInMonth(month - 1);
	let last = getDay(new Date(year, month - 1, daysInMonth));

	let cal = [];
	let d = 0;
	let day = 1;

	let currentWeek = []

	// leading zeros
	for(d = 0; d < first; d++)
		currentWeek.push({});

	let start = first;
	while(day <= daysInMonth)
	{
		// for(d = start; d < 7 && day <= daysInMonth; d++)
		for(d = start; d < 7; d++)
		{
			currentWeek.push({
				date: new DateTime(year, month, day),
				events: events.filter(e => e.startsOn.year == year && e.startsOn.month == month && e.startsOn.day == day)
			})
	
			day++;
		}

		start = 0;
		cal.push(currentWeek);
		currentWeek = []
	}

	// trailing zeros
	for(d = last; d < 7; d++)
		currentWeek.push({});

	return cal;
}